import { render, staticRenderFns } from "./fund-chart.vue?vue&type=template&id=4436642e&scoped=true"
import script from "./fund-chart.vue?vue&type=script&lang=js"
export * from "./fund-chart.vue?vue&type=script&lang=js"
import style0 from "./fund-chart.vue?vue&type=style&index=0&id=4436642e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4436642e",
  null
  
)

export default component.exports